export default __webpack_public_path__ + "static/media/olly-342x342.20865d3d.png";